export const calculateTax = (subtotal, taxRateString) => {
  const taxRatePercent = parseFloat(taxRateString) * 100;

  // Round to the nearest cent
  return Math.round(((subtotal * taxRatePercent) / 100) * 100) / 100;
};
